/* PLP Swatch Hover: image swap on hover, revert to active swatch on leave */
(function() {
  function initSwatchHover() {
    var lists = document.querySelectorAll(".product-swatches-options__list");
    if (!lists.length) return;

    lists.forEach(function(list) {
      if (list.dataset.swatchInit) return;
      list.dataset.swatchInit = "1";

      var swatches = list.querySelectorAll(".product-swatches-options__item");
      if (!swatches.length) return;

      var variantInfo = list.closest(".product-item__variant-info");
      if (!variantInfo) return;
      var meta = variantInfo.closest(".product-item__meta");
      if (!meta) return;
      var card = meta.parentElement;
      if (!card) return;

      var primaryImg = card.querySelector(".image__img");
      var imageLink = card.querySelector(".product-item__image-link");
      var titleLink = card.querySelector(".product-item__product-title a");
      if (!primaryImg) return;

      /* Helper: find which swatch is under the cursor */
      function hitTest(x, y) {
        for (var i = 0; i < swatches.length; i++) {
          var r = swatches[i].getBoundingClientRect();
          if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return swatches[i];
        }
        return null;
      }

      /* Helper: get the currently active (ringed) swatch */
      function getActiveSwatch() {
        return list.querySelector(".swatch-active") || swatches[0];
      }

      /* Helper: swap the product image */
      function showVariant(swatch) {
        var img = swatch.getAttribute("data-variant-image");
        var url = swatch.getAttribute("data-variant-url") || swatch.getAttribute("href");
        if (img) { primaryImg.src = img; primaryImg.srcset = ""; }
        if (url && imageLink) imageLink.setAttribute("href", url);
      }

      /* HOVER: mousemove hit-test */
      var lastHovered = null;
      list.addEventListener("mousemove", function(e) {
        var swatch = hitTest(e.clientX, e.clientY);
        if (swatch && swatch !== lastHovered) {
          lastHovered = swatch;
          showVariant(swatch);
        }
      });

      /* MOUSE LEAVE: always revert to whichever swatch has swatch-active class */
      list.addEventListener("mouseleave", function() {
        lastHovered = null;
        var active = getActiveSwatch();
        showVariant(active);
        /* Also ensure the product link points to the active variant */
        var url = active.getAttribute("data-variant-url") || active.getAttribute("href");
        if (url && titleLink) titleLink.setAttribute("href", url);
      });

      /* CLICK: set active swatch and hold */
      list.addEventListener("click", function(e) {
        var swatch = hitTest(e.clientX, e.clientY);
        if (!swatch) return;
        e.preventDefault();

        /* Update active ring */
        swatches.forEach(function(s) { s.classList.remove("swatch-active"); });
        swatch.classList.add("swatch-active");

        showVariant(swatch);

        /* Update title link */
        var url = swatch.getAttribute("data-variant-url") || swatch.getAttribute("href");
        if (url && titleLink) titleLink.setAttribute("href", url);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initSwatchHover();
      setTimeout(initSwatchHover, 1500);
    });
  } else {
    initSwatchHover();
    setTimeout(initSwatchHover, 1500);
  }
})();